import App from './App.svelte';

const app = new App({
	target:  document.querySelector('#fp-graf')
});

export default app;